export default __webpack_public_path__ + "static/media/quickbooks-online.b2442b16.svg";